module.exports = __webpack_public_path__ + "img/用户列表.6721ef04.svg";